import { useNavigate } from 'react-router-dom';
import { logoColor } from '../../ui/media';
import { themeStore } from '../../../stores/theme';
import { useStore } from '@tanstack/react-store';

const WaitingForReview = () => {
  const { isDarkMode } = useStore(themeStore)
  const navigate = useNavigate()

  const Logo = () => {
    return (
      <div className="flex flex-col items-center">
        <img src={logoColor} className='h-[70px]' />
      </div>
    );
  };

  return (
    <div className={`min-h-screen flex items-center justify-center p-4`}>
      <div className={`w-full max-w-md rounded-lg shadow-lg overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        {/* Logo Header */}
        <div className="bg-blue-100 w-[95%] mx-auto my-3 rounded-lg p-6 flex justify-center">
          <div className="flex flex-col items-center">
            <Logo />
          </div>
        </div>
        <h1 className={`text-2xl poppins-regular font-bold mt-4 py-6 text-center ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Your account is under review.</h1>
        <p className={`text-md mb-6 text-center ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
          Your account is currently under review. You will be notified once it has been approved by the administrator.
        </p>
        {/* Footer Link */}
        <div className={`p-4 text-center ${isDarkMode ? 'bg-gray-700' : 'bg-blue-100'}`}>
          <p>
            Click here to go back to 
            <button
              onClick={() => navigate("/login")}
              className="ml-1 poppins-regular font-bold text-blue-600 hover:underline">
              Login&nbsp;
            </button>
            Page
          </p>
        </div>
      </div>
    </div>
  );
};
export default WaitingForReview